// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-checkbox{font-size:18px;font-weight:600;color:#404040}.czt-checkbox .v-icon{color:#178fcf !important;font-size:30px}.czt-checkbox .v-input__control .v-input__slot{margin-bottom:0 !important}.czt-checkbox .v-input__control .v-input__slot .v-input--selection-controls__input .primary--text{color:#178fcf !important}", ""]);
// Exports
module.exports = exports;
